import { usePeriodSelection } from '@/hooks/usePeriodSelection';
import type { PeriodSelection } from '@/lib/period-presets';
import { spacePeriodFromSelection } from '@/lib/spaces/settlement';
import type { SpaceDetail } from '@/types/spaces';

// The period a space page shows is the app's period selection (the same picker every personal page uses), turned
// into the space's own key: one month for a house, the whole trip for a trip. See `spacePeriodFromSelection`.
export function useSpacePeriod(kind: SpaceDetail['kind']): { period: string; span: string; selection: PeriodSelection; onChange: (next: PeriodSelection) => void } {
  const { value, onChange } = usePeriodSelection();
  return { ...spacePeriodFromSelection(kind, value), selection: value, onChange };
}
